module.exports = __webpack_public_path__ + "img/dice-d6.37605d33.svg";